export default {"src":"/_next/static/media/loader.ea9e7501.gif","height":500,"width":500,"blurWidth":0,"blurHeight":0};